<template>
  <div>
    <TitleWrapper
      :filter-option="false"
      title="SUPPORT_QUERY_TYPE"
      tooltip-title="SUPPORT_QUERY_TYPE"
      :display-breadcrumb="true"
    ></TitleWrapper>
    <template v-if="isLoading"><Loader class="mt-20 mb-40" :content="true" /></template>
    <div v-else-if="!isLoading && isEmpty(supportQueryTypes)">
      <NoRecordFound />
    </div>
    <TableWrapper v-else>
      <THead>
        <TRHead>
          <TH
            v-for="head in tableHeaders.filter((head) => !head.skipForDataTableHead)"
            v-show="showColumnInDataTable(filtersData, head.dataTableName, skipForFilterColumns)"
            :key="head.id"
          >
            {{ head.dataTableName }}
          </TH>
        </TRHead>
      </THead>
      <TBody>
        <TRBody v-for="(type, index) in supportQueryTypes" :key="index">
          <TD v-show="showColumnInDataTable(filtersData, 'Title', ['Title'])">
            {{ type.title || GENERAL_CONSTANTS.NOT_APPLICABLE }}
          </TD>
          <TD v-show="showColumnInDataTable(filtersData, 'Description', ['Description'])">
            {{ type.description || GENERAL_CONSTANTS.NOT_APPLICABLE }}
          </TD>
          <TD v-show="showColumnInDataTable(filtersData, 'Actions', ['Actions'])">
            <TableAction
              :idx="index"
              :current-user="type"
              :action-list="actionList"
              @action="typeAction"
            />
          </TD>
        </TRBody>
      </TBody>
    </TableWrapper>
    <Pagination
      v-if="showPagination"
      v-show="!isLoading"
      :record-limit="GENERAL_CONSTANTS.RECORD_LIMIT"
      :max-range="paginationCounts(supportQueryTypesCounts, GENERAL_CONSTANTS.RECORD_LIMIT)"
      @filterRecord="getSupportQueryTypesList"
    />
    <SupportQueryTypeModal
      v-if="isModalShow"
      :modal="isModalShow"
      :edit="currentSupportQueryType"
      @toggle="toggleSupportQueryTypeModal"
    />
    <UIConfirmationModal
      v-if="deleteModelShow"
      :modal="deleteModelShow"
      heading="DELETE_SUPPORT_QUERY"
      message="Are you sure you want to delete "
      button-text="Delete"
      :name="currentSupportQueryType?.title"
      remaining-message="Support Query"
      @cancel="toggleDeleteModel"
      @confirm="deleteSupportQueryById"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TableAction from '@components/TableAction.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import { showColumnInDataTable } from '@utils/generalUtil'
import { paginationRangeHandler } from '@src/components/BaseComponent/pagination.util.js'
import Pagination from '@components/BaseComponent/Pagination.vue'
import isEmpty from 'lodash/isEmpty'
import scrollMixin from '@src/mixins/scroll-mixin'
import NoRecordFound from '@components/BaseComponent/NoRecordFound.vue'
import SupportQueryTypeModal from '@src/router/views/admin/modals/AddAndEditSupportQueryTypesModal.vue'
import { paginationCounts } from '@src/components/BaseComponent/pagination.util.js'
import UIConfirmationModal from '@src/components/UiElements/UIConfirmationModal.vue'
import generalMixin from '@src/mixins/general-mixins.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants.js'
import supportQueryTypesData from '@src/router/views/support-query/support-query-types/supportQueryTypesData.json'
import fileMixin from '@src/mixins/file-mixins'
import TitleWrapper from '@/src/components/TitleWrapper.vue'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'
export default {
  name: 'SupportQueryTypes',
  components: {
    TitleWrapper,
    TableAction,
    Loader,
    Pagination,
    UIConfirmationModal,
    NoRecordFound,
    SupportQueryTypeModal,
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
  },
  mixins: [fileMixin, scrollMixin, generalMixin],
  data() {
    return {
      GENERAL_CONSTANTS,
      filtersData: {},
      dashboard: 'dashboard',
      deleteModelShow: false,
      supportQueryTypes: [],
      modalButtonLoading: false,
      actionList: supportQueryTypesData.actionList,
      defaultSelectedColumns: supportQueryTypesData.defaultSelectedColumns,
      tableHeaders: supportQueryTypesData.tableHeaders,
      skipForFilterColumns: supportQueryTypesData.defaultSelectedColumns,
      supportQueryTypesCounts: GENERAL_CONSTANTS.EMPTY_RECORD,
      currentSupportQueryType: null,
      isModalShow: false,
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.layout.isLoading,
      activeRole: (state) => state.layout.activeRole,
    }),
    showPagination() {
      return this.supportQueryTypesCounts > GENERAL_CONSTANTS.RECORD_LIMIT
    },
  },

  mounted() {
    this.setRightbarData()
    this.getSupportQueryTypesList()
  },
  methods: {
    showColumnInDataTable,
    isEmpty,
    paginationCounts,

    deleteSupportQueryById() {
      this.deleteType(this.currentSupportQueryType?.id)
    },
    async getSupportQueryTypesList(range) {
      const paginationLimit = paginationRangeHandler(range)
      let payload = {
        ...paginationLimit,
      }
      payload = this.filtersData ? { ...payload, ...{ $where: this.filtersData?.$where } } : payload
      const [res, err] = await this.getSupportQueryTypes(payload)
      if (!err) {
        this.supportQueryTypes = res?.data?.records
        this.supportQueryTypesCounts = res?.data?.meta?.total_records
        this.setRightbarData(res.data?.meta?.total_records)
      }
    },
    toggleSupportQueryTypeModal(payload) {
      this.isModalShow = !this.isModalShow
      if (!this.isModalShow) this.currentSupportQueryType = null
      if (payload) this.getSupportQueryTypesList()
    },
    typeAction(action, currentType, idx) {
      this.currentSupportQueryType = currentType
      switch (action) {
        case 'Edit':
          this.toggleSupportQueryTypeModal()
          break
        case 'Delete':
          this.toggleDeleteModel()
          break
      }
    },

    async deleteType(id) {
      await this.deleteSupportQueryType(id)
      this.toggleDeleteModel()
      this.getSupportQueryTypesList()
    },
    toggleDeleteModel() {
      this.deleteModelShow = !this.deleteModelShow
      if (!this.deleteModelShow) this.currentSupportQueryType = null
    },

    setRightbarData(length = GENERAL_CONSTANTS.EMPTY_RECORD) {
      const rightBarContent = {
        header: {
          title: 'SUPPORT_QUERY_TYPES',
          buttons: [
            {
              title: 'ADD_SUPPORT_QUERY_TYPE',
              classes: ['primary-button-right'],
              action: {
                func: () => {
                  this.toggleSupportQueryTypeModal()
                },
              },
            },
          ],
        },
        stats: [
          {
            title: GENERAL_CONSTANTS.STATS_AND_SUMMARY,
            categories: [{ text: 'Total Types', value: length }],
          },
        ],
      }
      this.setRightbarContent(rightBarContent)
    },
    ...mapActions('layout', ['setRightbarContent', 'setShowModal']),
    ...mapActions('supportQuery', ['getSupportQueryTypes', 'deleteSupportQueryType']),
  },
}
</script>
